import React from "react";
import { FeatureFlagContext } from "../../../utilities/contexts";

const ECLFeatureFlag = (props) => {
   //PROPS:
   //ffKey - string - must match the string in state in FFContext to turn on/off

   return (
      <FeatureFlagContext.Consumer>
         {(value) => {
            if (value.flagSettings[props.ffKey] === undefined) {
               console.error(
                  `${props.ffKey} is not defined in the FeatureFlagContext. 
                    Fix this to make your feature flag work.`,
               );
               return null;
            } else if (value.flagSettings[props.ffKey] === true) {
               return props.children;
            } else {
               return null;
            }
         }}
      </FeatureFlagContext.Consumer>
   );
};

export default ECLFeatureFlag;
